function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var WitnessTemplate = require('./witness.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');

//
// Witness field names per opcode (mirrors rustscript exampleScript.witness keys).
//
var WITNESS_FIELDS_BY_OP = {
  CHECKOWNNFT: ['utxokey1', 'utxokey2', 'utxokey3'],
  CHECKOWNNFTWHERE: ['utxokey1', 'utxokey2', 'utxokey3'],
  CHECKHASH: ['input'],
  CHECKSIG: ['signature'],
  CHECKMULTISIG: ['signatures'],
  CHECKPATH: ['path'],
  CHECKPATHHOP: ['hops'],
  IMPORTFIELD: ['value']
};
var UTXOKEY_VAULT_FIELDS = {
  utxokey1: 'slip1_utxokey',
  utxokey2: 'slip2_utxokey',
  utxokey3: 'slip3_utxokey'
};
function isWitnessValueMissing(value) {
  return value === undefined || value === null || value === '';
}
function prepareAccessScript(access_script) {
  var vault_entry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var script = typeof access_script === 'string' ? JSON.parse(access_script) : JSON.parse(JSON.stringify(access_script));
  var op = script === null || script === void 0 ? void 0 : script.op;
  var witnessFields = WITNESS_FIELDS_BY_OP[op];
  if (witnessFields) {
    if (!script.witness || _typeof(script.witness) !== 'object' || Array.isArray(script.witness)) {
      script.witness = {};
    }
    var _iterator = _createForOfIteratorHelper(witnessFields),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var field = _step.value;
        if (!isWitnessValueMissing(script.witness[field])) {
          continue;
        }
        var vaultField = UTXOKEY_VAULT_FIELDS[field];
        if (vaultField && vault_entry && vault_entry[vaultField]) {
          script.witness[field] = vault_entry[vaultField];
        } else {
          script.witness[field] = '';
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else if (script.witness && _typeof(script.witness) === 'object' && !Array.isArray(script.witness)) {
    for (var _i = 0, _Object$keys = Object.keys(script.witness); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      if (script.witness[key] === undefined || script.witness[key] === null) {
        script.witness[key] = '';
      }
    }
  }
  return script;
}
var Witness = /*#__PURE__*/function () {
  function Witness(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, Witness);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.callback = null;
    this.access_script = null;
    this.vault_entry = null;
  }
  return _createClass(Witness, [{
    key: "render",
    value: function render() {
      var _this = this;
      this.overlay.show(WitnessTemplate(this.app, this.mod, this));
      setTimeout(function () {
        var scriptTextarea = document.querySelector('.witness-access-script-textarea');
        if (scriptTextarea && _this.access_script) {
          try {
            var scriptObj = prepareAccessScript(_this.access_script, _this.vault_entry);
            scriptTextarea.value = JSON.stringify(scriptObj, null, 2);
          } catch (err) {
            scriptTextarea.value = typeof _this.access_script === 'string' ? _this.access_script : JSON.stringify(_this.access_script, null, 2);
          }
        }
        _this.attachEvents();
      }, 25);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      try {
        document.getElementById('download_with_witness_btn').onclick = function (e) {
          var access_script = document.querySelector('.witness-access-script-textarea').value;
          if (!access_script || access_script.trim() === '') {
            salert('Please provide an access script to proceed.');
            return;
          }
          try {
            JSON.parse(access_script);
          } catch (err) {
            salert('Invalid JSON format in access script. Please check your input.');
            return;
          }
          if (_this2.callback) {
            _this2.callback({
              access_script: access_script
            });
            _this2.overlay.remove();
          } else {
            salert('Error: No callback function defined.');
          }
        };
        var helpLink = document.getElementById('witness-help-link');
        if (helpLink) {
          helpLink.onclick = function (e) {
            salert('Edit the full access script JSON, including any witness fields required by the opcode. For example:\n\n' + '{\n  "op": "CHECKHASH",\n  "hash": "...",\n  "witness": { "input": "" }\n}\n\n' + 'or\n\n' + '{\n  "op": "CHECKOWNNFT",\n  "nftid": "...",\n  "witness": {\n    "utxokey1": "",\n    "utxokey2": "",\n    "utxokey3": ""\n  }\n}');
          };
        }
      } catch (err) {
        console.error('Witness overlay attachEvents error:', err);
      }
    }
  }]);
}();
module.exports = Witness;